import { ReactElement, FormEvent, ChangeEvent } from "react";
import { Form } from "@justworkshr/milo-form";
import { Button } from "@justworkshr/milo-core";

import {
  UserRegistrationForm,
  InlineError,
  TextInputField,
} from "../../types/userRegistrationForm";
import { RegistrationInputValidationMap } from "pages/register/types/userRegistrationForm";

import TextInputFormField from "../textInputFormField/TextInputFormField";
import FooterButtons from "../footerButtons/FooterButtons";

import styles from "./name-and-email-form.module.css";

const NameAndEmailForm = ({
  formData,
  inlineError = {},
  inputValidation,
  onComplete,
  onCancel,
  onChangeInput,
}: {
  formData: UserRegistrationForm;
  inlineError?: InlineError;
  inputValidation: RegistrationInputValidationMap;
  onComplete: () => void;
  onCancel: () => void;
  onChangeInput: (inputField: TextInputField, value: string) => void;
}): ReactElement => {
  const changeHandler =
    (inputField: TextInputField) => (e: ChangeEvent<HTMLInputElement>) =>
      onChangeInput(inputField, e.target.value);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onComplete();
    window.scrollTo(0, 0);
  };

  const formValid = () => {
    if (formData.firstName === "" || formData.lastName === "") return false;

    return inputValidation.email.isValid;
  };

  return (
    <Form onSubmit={onSubmit}>
      <div className={styles.inputsContainer}>
        <TextInputFormField
          isRequired={true}
          formField={{
            label: "First name",
            error: inlineError.firstName,
          }}
          textInput={{
            name: TextInputField.FirstName,
            value: formData.firstName,
            onChange: changeHandler(TextInputField.FirstName),
          }}
        />

        <TextInputFormField
          isRequired={true}
          formField={{
            label: "Last name",
            error: inlineError.lastName,
          }}
          textInput={{
            name: TextInputField.LastName,
            value: formData.lastName,
            onChange: changeHandler(TextInputField.LastName),
          }}
        />

        <TextInputFormField
          formField={{
            label: "Preferred name",
            message:
              "What would you like us to call you? This is the name you’ll see in your company directory and in emails from us.",
          }}
          textInput={{
            name: TextInputField.PreferredName,
            value: formData.preferredName,
            onChange: changeHandler(TextInputField.PreferredName),
          }}
        />

        <TextInputFormField
          isRequired={true}
          formField={{
            label: "Personal email",
            message:
              "Add your personal email in case you forget your username or password.",
            error: inlineError.email,
          }}
          textInput={{
            name: TextInputField.Email,
            value: formData.email,
            onChange: changeHandler(TextInputField.Email),
          }}
        />
      </div>

      <FooterButtons>
        <Button variant={"ghost"} onClick={onCancel}>
          Back
        </Button>
        <Button type={"submit"} rightIcon="arrow-right" disabled={!formValid()}>
          Next
        </Button>
      </FooterButtons>
    </Form>
  );
};

export default NameAndEmailForm;
